module.exports = __webpack_public_path__ + "static/offer-letter-f18565fa0ffcfe7f0c0f4b3fdb617704.png";